import { ClientDataServiceApi } from '../clients/client'
import { API_CONFIG } from '../config'
import { apiClient } from '../http'

// Все запросы идут через nginx (BASE_URL). PURE — модуль без побочных эффектов:
// клиент уходит в чанки экранов, которые его зовут, а не во входной (DEV-2503).
export const clientDataApi = /* @__PURE__ */ new ClientDataServiceApi(
  undefined,
  API_CONFIG.BASE_URL,
  apiClient,
)
